//Sidebar sections toggle
$('#leftnav .icon').each(function () {
    $(this).on('click', function (event) {
        $(this).toggleClass('expanded');
        $(this).next().toggleClass("hide");
    });
});

//Content sections toggle
$('#content .content_h2').each(function () {
    $(this).on('click', function (event) {

        if ($('img', this).hasClass("collapsed")) {
            $('img', this).attr("src", "https://static3.avast.com/1/web/i/v2/pages/legal/arrow_up.svg");
            $('img', this).toggleClass("expanded collapsed");
        } else if ($('img', this).hasClass("expanded")) {
            $('img', this).attr("src", "https://static3.avast.com/1/web/i/v2/pages/legal/arrow_down.svg");
            $('img', this).toggleClass("collapsed expanded");
        }

        $(this).nextUntil(".content-block").each(function () {
            $(this).toggleClass("hide");
        })
    })
})
